export {};
//# sourceMappingURL=class-constructor.type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/class-constructor.type.js
// module id = 788
// module chunks = 3